import { ProductGroups } from "../../../../../modules/merchant/admin/products/productsTypes"

// Deliberately kept out of filterShops: that one also builds the "product still exists in the shop
// list" lookup in MeetingServiceDelivery, which must keep seeing the full catalog — otherwise a
// merchant's own admin-only order line would be flagged as missing and blocked from increasing.
export const filterOutAdminOnlyProducts = (productGroups: ProductGroups[]): ProductGroups[] =>
    productGroups
        .map((group) => ({ ...group, products: group.products?.filter((product) => !product.isAdminOnly) ?? [] }))
        .filter((group) => group.products.length > 0)

export const filterShops = (
    isFavorite: boolean,
    searchRegex: RegExp | undefined,
    productGroups?: ProductGroups[],
): ProductGroups[] | undefined => {
    if (!productGroups || (!isFavorite && !searchRegex)) return productGroups

    const filteredGroups: ProductGroups[] = productGroups
        .map((group) => {
            const filteredProducts = group?.products?.filter((product) => {
                const isProductFavorite = isFavorite ? !!product?.userDetails?.isFavorite : true
                const passesSearch = searchRegex ? searchRegex.test(product.name) : true
                return isProductFavorite && passesSearch
            })

            if (filteredProducts && filteredProducts.length > 0) {
                return {
                    ...group,
                    products: filteredProducts,
                }
            }

            return null
        })
        .filter((group): group is ProductGroups => group !== null)

    if (filteredGroups.length === 0) return undefined

    return filteredGroups
}
